import { ImportVO } from 'library/ts/model/vo/ImportVO';
import { LogService } from 'library/ts/utilities/logger/LogService';
import { Constants } from 'tag/ts/smart_tag/model/Constants';
import { NewRelicManager } from 'tag/ts/tag/metrics/NewRelicManager';
const logger = LogService.create({ prefixes: ['SmartTag:'] });
const preloadImports = (importsConfig) => {
    const utils = window.SmartTag.utilities;
    const runtimeVO = window.SmartTag.runtimeVO;
    if (runtimeVO?.readyCallback?.payload?.relative === true) {
        Object.keys(importsConfig).forEach((key) => {
            const oneImport = (importsConfig)[key];
            oneImport.url.regular = utils.URL.convertToRelative(oneImport?.url?.regular);
        });
    }
    const imports = [];
    Object.keys(importsConfig).forEach((key) => {
        const importable = importsConfig[key];
        const importType = 'regular';
        if (utils.Import.alreadyPresent(importable.url[importType], importable.namespace) === false) {
            let url = importable.url[importType];
            if (url.indexOf(window.PlayerServicesProjectInfo.app_output_file.tag.js.min.value.replace('.js', '')) > -1) {
                url = utils.URL.addCacheToken(url, runtimeVO.debug.cacheBust);
            }
            const newImport = new ImportVO(importable.type, url, importable.namespace, window);
            newImport.order = importable.order;
            imports.push(newImport);
            imports.sort(utils.Array.sortByProperty('order'));
        }
    });
    logger.log('preloadImports:', 'imports', imports);
    return new Promise((resolve, reject) => {
        utils.Importer.import(imports, true).then((data) => {
            logger.log('preloadImports:', 'Importer:', 'Done:', data);
            resolve(data);
        }).catch((error) => {
            logger.warn('preloadImports:', 'Importer:', 'ERROR:', error);
            reject(error);
        });
    });
};
export const executeSmartTagReadyPageCallback = (smartTag) => {
    const utils = smartTag.utilities;
    const callbackObject = smartTag?.runtimeVO?.readyCallback;
    const executeReadyCallback = () => {
        if (utils.Type.isFunction(callbackObject.method)) {
            logger.log('executeReadyCallback:', 'Default callback was found:', callbackObject.method, 'Execute...');
            try {
                utils.Delay.delay(utils.Type.isNumber(callbackObject.delay) ? callbackObject.delay : undefined)
                    .then(() => {
                    callbackObject.method(smartTag);
                });
            }
            catch (error) {
                logger.warn('executeReadyCallback:', 'Callback error:', error);
            }
        }
        else {
            logger.warn('executeReadyCallback:', 'Callback is not set or', 'Default callback:', Constants.getInstance().FUNCTION_SMART_TAG_ON_READY, 'does not exist on page.', 'Abort.');
        }
    };
    if (utils.Type.isObject(callbackObject)) {
        utils.Delay.delay().then(() => {
            NewRelicManager.getInstance().initialize(smartTag?.runtimeVO, smartTag?.info?.version)
                .then((data) => {
                logger.log('executeSmartTagReadyPageCallback:', 'New Relic initialized:', data, 'Execute callback.');
            })
                .then(() => utils.Delay.delay(10))
                .then(() => {
                if (utils.Type.isObject(callbackObject?.payload?.imports) && Object.keys(callbackObject.payload.imports).length > 0) {
                    logger.log('Preload imports...');
                    preloadImports(callbackObject.payload.imports).then((data) => {
                        logger.log('preloadImports:', 'Preload success:', data, 'Execute callback.');
                        executeReadyCallback();
                    }).catch((error) => {
                        logger.warn('preloadImports:', 'Preload failure:', error, 'Execute callback.');
                        executeReadyCallback();
                    });
                }
                else {
                    executeReadyCallback();
                }
            })
                .catch((data) => {
                logger.warn('executeSmartTagReadyPageCallback:', 'ERROR:', data);
            });
        });
    }
};
